import axios from './api'
const LoginServer = {	
    //账号密码登录
    Login(params) {
		return axios.post(`/org/user/auth/login`, params).then((res) => {
            return res.data
        })
	},

    //手机号验证码登录
    LoginByVerificationCode(params) {
		return axios.post(`/org/user/auth/phoneLogin`, params).then((res) => {
            return res.data
        })
	},

    //发送短信验证码
    getSMSCode(params) {
		return axios.post(`/org/base/sms/send`, params).then((res) => {
            return res.data
        })
	},

    //登出
    Logout(params) {
		return axios.get(`/org/user/auth/logout`, params).then((res) => {
            return res.data
        })
	},
}
export default LoginServer


// WEBPACK FOOTER //
// ./src/api/login.js